module.exports = __webpack_public_path__ + "static/media/logo_masary.0dbcd0dd.png";